/** One row from site listing API `results[]` (paginated envelope is not stored in RxDB). */
export const prospectiveSiteSchema = {
	schema: {
		title: 'Prospective site schema',
		description: 'Prospective / site listing row',
		version: 3,
		primaryKey: 'id',
		type: 'object',
		properties: {
			id: {
				type: 'string',
				maxLength: 250,
			},
			sfid: {
				type: 'string',
			},
			app_id_c: {
				type: 'string',
			},
			name: {
				type: 'string',
			},
			site_location_c: {
				type: 'string',
			},
			address_c: {
				type: 'string',
			},
			site_state_c: {
				type: 'string',
			},
			pincode_c: {
				type: 'string',
			},
			site_city_c: {
				type: 'string',
			},
			location_captured_latitude_s_c: {
				type: 'number',
			},
			location_captured_longitude_s_c: {
				type: 'number',
			},
			source_of_site_lead_c: {
				type: 'string',
			},
			type_of_work_c: {
				type: 'string',
			},
			project_type_c: {
				type: 'string',
			},
			sub_classification_c: {
				type: 'string',
			},
			createddate: {
				type: 'string',
				format: 'date-time',
			},
			lastmodifieddate: {
				type: 'string',
				format: 'date-time',
			},
			is_dr_required: {
				type: 'boolean',
			},
			sitenumber_c: {
				type: 'string',
			},
			type_of_record_c: {
				type: 'string',
			},
		},
		required: [
			'id',
			'sfid',
			'app_id_c',
			'name',
			'site_location_c',
			'address_c',
			'site_state_c',
			'pincode_c',
			'site_city_c',
			'location_captured_latitude_s_c',
			'location_captured_longitude_s_c',
			'source_of_site_lead_c',
			'type_of_work_c',
			'project_type_c',
			'sub_classification_c',
			'createddate',
			'lastmodifieddate',
			'sitenumber_c',
			'type_of_record_c',
		],
	},
	migrationStrategies: {
		1: (oldDoc: Record<string, unknown>): Record<string, unknown> => ({
			...oldDoc,
			sitenumber_c: typeof oldDoc.sitenumber_c === 'string' ? oldDoc.sitenumber_c : '',
		}),
		2: (oldDoc: Record<string, unknown>): Record<string, unknown> => {
			const rest = { ...oldDoc };
			delete rest.person_of_contact_c;
			delete rest.person_contact_name_c;
			delete rest.person_contact_number_c;
			return rest;
		},
		3: (oldDoc: Record<string, unknown>): Record<string, unknown> => ({
			...oldDoc,
			type_of_record_c: typeof oldDoc.type_of_record_c === 'string' ? oldDoc.type_of_record_c : '',
		}),
	},
};
